var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('banner'), _vm._v(" "), _vm._m(0)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('figure', [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/YGjpZp_FM1E?rel=0",
      "width": "640",
      "height": "390",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('figcaption', [_vm._v("とり野菜みそCM映像")])]), _vm._v(" "), _c('figure', [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/bWvzF5LcMaU?rel=0",
      "width": "640",
      "height": "390",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('figcaption', [_vm._v("CMメイキング映像")])]), _vm._v(" "), _c('a', {
    staticClass: "btnBrandtop",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_footer.svg"),
      "alt": "とり野菜みそオフィシャルサイトへ"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e76546ae","hasScoped":true,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Video.vue
// module id = 64
// module chunks = 0